import { OpenNewTabTargetType } from "@voltmoney/types";
import { ButtonTypeTokens, InputStateToken } from "@voltmoney/schema";
import { getAuthHeaders, RegexConfig } from "../../configs/config";
import SharedPropsService from "../../SharedPropsService";
import sharedPropsService from "../../SharedPropsService";
import { api } from "../../configs/api";
import { getParameters, isEmpty } from "../../configs/utils";
import { AppLink, GoogleUtmParams } from "../../configs/constants";
import { Platform } from "react-native";
const leadDetails = sharedPropsService.getMarketingLeadsData();
// @ts-ignore
let haveMutualFunds = `${leadDetails?.haveMutualFunds ? leadDetails.haveMutualFunds : ''}`;
// @ts-ignore
let name = `${leadDetails?.fullName ? leadDetails.fullName : ''}`;
// @ts-ignore
let phone = `${leadDetails?.phoneNumber ? leadDetails?.phoneNumber : ''}`;
// @ts-ignore
let portfolioValue = `${leadDetails.assetDetail ? leadDetails.assetDetail : ''}`;
const isWhatsAppEnabled = false;
const resendAttempts = 1;
export const changeInput = async (action, _datastore, { navigate, goBack, setDatastore, analytics }) => {
    console.warn("**** SelectHaveNotHaveMF Action Triggered ****", action);
    //handle haveMutualFunds
    if (action.payload.widgetID === 'MarketingLeadsCheckMFOption') {
        haveMutualFunds = action.payload.value;
        if (haveMutualFunds === 'Yes') {
            analytics('mf_yes', {});
            await setDatastore(action.routeId, 'MarketingLeadsYesContainer', { hide: false });
            await setDatastore(action.routeId, 'MarketingLeadsNoContainer', { hide: true });
            await setDatastore(action.routeId, 'MarketingLeadsBottomParentBanner', { hide: false });
        }
        if (haveMutualFunds === 'No') {
            analytics('mf_no', {});
            await setDatastore(action.routeId, 'MarketingLeadsYesContainer', { hide: true });
            await setDatastore(action.routeId, 'MarketingLeadsNoContainer', { hide: false });
            await setDatastore(action.routeId, 'MarketingLeadsBottomParentBanner', { hide: true });
        }
    }
    //handle phone number
    if (action.payload.widgetID === 'MarketingLeadsYesContainer_phoneNumber') {
        phone = action.payload.value;
    }
    //handle name
    if (action.payload.widgetID === 'MarketingLeadsYesContainer_fullName') {
        name = action.payload.value;
    }
    //handle name select porfolio value
    if (action.payload.widgetID === 'MarketingLeadsYesContainer_selectPorfolioValue') {
        // switch (action.payload.value) {
        //     case ASSET_DETAILS_VALUE.AMOUNT_10K_50K:
        //         analytics('portfolio_10k_50k', {});
        //         break;
        //
        //     case ASSET_DETAILS_VALUE.AMOUNT_50K_2L:
        //         analytics('portfolio_50k_2l', {});
        //         break;
        //
        //     case ASSET_DETAILS_VALUE.AMOUNT_2L_10L:
        //         analytics('portfolio_2l_10L', {});
        //         break;
        //
        //     case ASSET_DETAILS_VALUE.AMOUNT_ABOVE_10L:
        //         analytics('portfolio_more_than_10', {});
        //         break;
        //
        //     default: break;
        // }
        portfolioValue = action.payload.value;
    }
    const phoneNumberRegex = new RegExp(RegexConfig.NEW_MOBILE);
    const isPhoneNumberValid = phoneNumberRegex.test(phone);
    if (isPhoneNumberValid && name && portfolioValue) {
        await setDatastore(action.routeId, 'ApplyNowBtn', {
            type: ButtonTypeTokens.LargeFilled
        });
    }
    else {
        await setDatastore(action.routeId, 'ApplyNowBtn', {
            type: ButtonTypeTokens.LargeOutline
        });
    }
};
export const toggleCTA = async (action, _datastore, { setDatastore }) => {
    console.warn("**** toggleCTA Action Triggered ****", action);
    const phoneNumberRegex = new RegExp(RegexConfig.NEW_MOBILE);
    const isPhoneNumberValid = phoneNumberRegex.test(phone);
    if (action.payload.value && isPhoneNumberValid && name && haveMutualFunds && portfolioValue) {
        await setDatastore(action.routeId, 'ApplyNowBtn', {
            type: ButtonTypeTokens.LargeFilled
        });
    }
    else {
        await setDatastore(action.routeId, 'ApplyNowBtn', {
            type: ButtonTypeTokens.LargeOutline
        });
    }
};
export const onClosePopup = async (action, _datastore, { hidePopup }) => {
    console.warn("**** onClosePopup Action Triggered ****", action);
    hidePopup();
};
export const onApplyNow = async (action, _datastore, { analytics, network, setDatastore, instrumentTrack, navigateToBase, openNewTab }) => {
    console.warn("**** onApplyNow Action Triggered ****", action);
    phone = phone.includes("+91") ? phone : `+91${phone}`;
    const isResend = action.payload.isResend;
    instrumentTrack("OTP_SENT");
    if (action.payload.isResend) {
        instrumentTrack("RESEND_OTP_BUTTON_CLICKED", { "attempt_count": resendAttempts });
    }
    await setDatastore(action.routeId, 'ApplyNowBtn', {
        loading: true
    });
    if (phone.length === 13) {
        await sharedPropsService.setMarketingLeadsData({
            phoneNumber: phone,
            fullName: name,
            haveMutualFunds: haveMutualFunds,
            assetDetail: portfolioValue
        });
        switch (portfolioValue) {
            case "AMOUNT_10K_50K" /* ASSET_DETAILS_VALUE.AMOUNT_10K_50K */:
                analytics('portfolio_10k_50k', {});
                break;
            case "AMOUNT_50K_2L" /* ASSET_DETAILS_VALUE.AMOUNT_50K_2L */:
                analytics('portfolio_50k_2l', {});
                break;
            case "AMOUNT_2L_10L" /* ASSET_DETAILS_VALUE.AMOUNT_2L_10L */:
                analytics('portfolio_2l_10L', {});
                break;
            case "AMOUNT_ABOVE_10L" /* ASSET_DETAILS_VALUE.AMOUNT_ABOVE_10L */:
                analytics('portfolio_more_than_10', {});
                break;
            default: break;
        }
        await setDatastore(action.routeId, action.payload.widgetId, {
            loading: true,
        });
        const urlParams = `${await SharedPropsService.getUrlParams()}`.split("?");
        const requestUrl = `${api.login}${phone}`;
        const params = urlParams ? getParameters(await SharedPropsService.getUrlParams()) : {};
        let createUtmObject = {};
        Object.keys(params).forEach((key) => {
            switch (key) {
                case GoogleUtmParams.UTM_CAMPAIGN:
                    createUtmObject = {
                        utmCampaign: params[key],
                        ...createUtmObject
                    };
                    break;
                case GoogleUtmParams.UTM_CONTENT:
                    createUtmObject = {
                        utmContent: params[key],
                        ...createUtmObject
                    };
                    break;
                case GoogleUtmParams.UTM_MEDIUM:
                    createUtmObject = {
                        utmMedium: params[key],
                        ...createUtmObject
                    };
                    break;
                case GoogleUtmParams.UTM_SOURCE:
                    createUtmObject = {
                        utmSource: params[key],
                        ...createUtmObject
                    };
                    break;
                case GoogleUtmParams.UTM_TERM:
                    createUtmObject = {
                        utmTerm: params[key],
                        ...createUtmObject
                    };
                    break;
            }
        });
        console.log("createUtmObject 123: ", createUtmObject);
        let registerLeadsResponse;
        if (isResend === false) {
            let registerLeadBody = {
                leadMetadata: {
                    assetRange: portfolioValue,
                    hasSecurityAssets: 'Yes'
                },
                phoneNumber: phone,
                fullName: name,
                leadTrackingDetails: createUtmObject,
                source: 'MARKETING_NON_MFC',
            };
            if (!isEmpty(createUtmObject)) {
                registerLeadBody = {
                    ...registerLeadBody,
                    leadTrackingDetails: createUtmObject
                };
            }
            registerLeadsResponse = await network.post(`${api.RegisterALead}`, registerLeadBody, {
                headers: await getAuthHeaders()
            }, async () => {
                return;
            }, {
                //@ts-ignore
                isPartnerPlatform: true,
            });
        }
        //get otp
        const response = await network.get(`${requestUrl}?enableWhatsapp=${isWhatsAppEnabled}${urlParams.length > 1 ? `&${urlParams[1]}` : ""}`, {
            headers: await getAuthHeaders(),
        });
        if (isResend === true) {
            await setDatastore(action.routeId, "input", {
                state: InputStateToken.DEFAULT,
            });
        }
        if (response.status === 200) {
            //need to call register a lead api
            if (registerLeadsResponse?.status === 200) {
                const lead = registerLeadsResponse?.data;
                const leadId = lead?.leadId;
                await setDatastore(action.routeId, action.payload.widgetId, {
                    loading: false,
                });
                if (action.payload.isResend == false) {
                    await setDatastore(action.routeId, 'ApplyNowBtn', {
                        loading: false
                    });
                    // await navigateToBase(ROUTE.MARKETING_LEAD_OTP, {
                    //     phone_number: phone,
                    //     lead: lead
                    // });
                    // await openNewTab(`${AppLink}?startnew=true&leads=${phone.toString().slice(3)}`);
                    await openNewTab(`${AppLink}?startnew=true&leads=${phone.toString().slice(3)}&leadId=${leadId}`, OpenNewTabTargetType.parent);
                }
                if (action.payload.isResend == false) {
                    await setDatastore(action.routeId, "input", {
                        state: InputStateToken.SUCCESS,
                    });
                }
            }
            else {
                await setDatastore(action.routeId, 'ApplyNowBtn', {
                    loading: false
                });
                if (registerLeadsResponse?.response?.data?.voltErrorCode?.includes("CUSTOMER_LEAD_EXISTS")) {
                    // await navigateToBase(ROUTE.MARKETING_LEAD_OTP, {doLeadExist: true,  phone_number: phone})
                    // await openNewTab(`${AppLink}?startnew=true&leads=${phone.toString().slice(3)}`);
                    await openNewTab(`${AppLink}?startnew=true&leads=${phone.toString().slice(3)}`, OpenNewTabTargetType.parent);
                }
            }
        }
        else {
            if (response?.response?.data?.voltErrorCode?.includes("ACCOUNT_BLOCKED_FROM_OTP")) {
                await setDatastore(action.routeId, "input", {
                    state: InputStateToken.ERROR,
                    caption: { error: "OTP limit exceeded. Please retry in 5 minutes." }
                });
                await setDatastore(action.routeId, action.payload.widgetId, {
                    loading: false,
                });
                await setDatastore(action.routeId, "ApplyNowBtn", {
                    type: ButtonTypeTokens.LargeOutline
                });
            }
            else {
                await setDatastore(action.routeId, "input", {
                    state: InputStateToken.ERROR,
                });
                instrumentTrack("INVALID_OTP_ENTERED");
                await setDatastore(action.routeId, action.payload.widgetId, {
                    loading: false,
                });
            }
            await setDatastore(action.routeId, 'ApplyNowBtn', {
                loading: false
            });
        }
    }
    else {
        await setDatastore(action.routeId, "input", {
            state: InputStateToken.ERROR,
        });
        await setDatastore(action.routeId, 'ApplyNowBtn', {
            loading: false
        });
    }
};
export const onChangeDimension = async (action, _datastore, { hidePopup }) => {
    console.warn("**** onChangeDimension Action Triggered ****", action);
    const widthX = action.payload.width;
    const heightX = action.payload.height;
    const dimensionData = {
        height: heightX,
        width: widthX
    };
    if (Platform.OS === 'web') {
        // const dimensionEvent = new EventEmitter();
        // dimensionEvent.emit('getDimensionMarketing',  {id: 'getDimensionMarketing', data: dimensionData});
        //send message to parent iframe about dimension changes
        window.parent.postMessage({ id: 'getDimensionLeads', data: dimensionData }, '*');
    }
};
export const onSelectPortfolio = async (action, _datastore, { setDatastore }) => {
    console.warn("**** onSelectPortfolio Action Triggered ****", action);
    const check = action.payload.value;
    if (check) {
        await setDatastore(action.routeId, 'MarketingLeadsYesContainerSpaceStack1', {
            hide: false
        });
    }
    else {
        await setDatastore(action.routeId, 'MarketingLeadsYesContainerSpaceStack1', {
            hide: true
        });
    }
};
